<template>
  <!-- app协议 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.system.text32')">
          <el-select
            v-model="searchParams.functionCode"
            :placeholder="$t('button.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text36')">
          <el-input
            v-model="searchParams.agreementName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text3')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['appAgreement:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['appAgreement:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['appAgreement:add']"
      ></DiluButton>
      <DiluButton
        type="delete"
        @click="remove"
        v-permission="['appAgreement:remove']"
        v-if="selectIds.length > 0"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <el-table-column type="selection" width="40"> </el-table-column>
      <el-table-column prop="date" label="#" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="functionCode"
        :label="$t('pages.system.text32')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="agreementName"
        :label="$t('pages.system.text36')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdBy"
        :label="$t('pages.system.text6')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        :label="$t('pages.system.text3')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['appAgreement:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['appAgreement:edit']"
              >{{ $t("button.edit") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <AppgreementAddModule
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      :options="options"
      @appAgreementList="appAgreementList"
      :dialogStatus="dialogStatus"
      :currentAgreement="currentAgreement"
    />
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import AppgreementAddModule from "./module/appgreementAddModule.vue";
import { resetDate } from "../../../utils/util/validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      dialogStatus: 0, // 当前弹窗状态
      currentAgreement: {}, //当前选中协议
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      searchParams: {
        agreementName: "", //协议名称
        startAt: "", //上传开始时间
        stopAt: "", //上传结束时间
        functionCode: "", //应用路径
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        appCode: "",
      },
      options: [],
      tableData: [],
      selectIds: [],
      isSerch: false, //是否在查询
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    DiluButton,
    AppgreementAddModule,
  },
  mounted() {
    this.appAgreementGetFunctionCode();
    this.appAgreementList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.appAgreementList();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        agreementName: "", //协议名称
        startAt: "", //上传开始时间
        stopAt: "", //上传结束时间
        functionCode: "", //应用路径
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      };
      this.total = 0;
      this.appAgreementList();
    },
    //删除协议
    remove() {
      this.$confirm(this.$t("pages.system.text37"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let arr = this.selectIds;
          this.request.appAgreementDelete({ ids: arr }).then(() => {
            this.total = 0;
            this.searchParams.pageNum = 1;
            this.$message.success(this.$t("public.text7"));
            this.appAgreementList();
          });
        })
        .catch(() => {});
    },

    //选中触发
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.id;
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          agreementName: "", //协议名称
          startAt: "", //上传开始时间
          stopAt: "", //上传结束时间
          functionCode: "", //应用路径
          pageNum: 1, //页码
          pageSize: 10, //每页条数
        };
      }
      this.searchParams.pageNum = e;
      this.appAgreementList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //新增
    add() {
      this.dialogStatus = 0;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.dialogStatus = 2;
      this.currentAgreement = e;
      this.dialogVisible = true;
    },
    //编辑
    edit(e) {
      this.dialogStatus = 1;
      this.currentAgreement = e;
      this.dialogVisible = true;
    },
    //app协议-查出所有应用路径
    appAgreementGetFunctionCode() {
      this.request.appAgreementGetFunctionCode().then((res) => {
        this.options = res.data;
      });
    },
    //app协议-列表（分页）
    appAgreementList() {
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.searchParams.appCode = this.platformData.appCode;
      this.request.appAgreementList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>